import { useWebgate } from '@xvia/webgate-connect';
import { getServerData } from '../util/get-server-data';
import { IJourney } from '../apis/journeys';

/**
 * A árvore de jornadas vem pronta do SSR — o cliente não fala com o CMS (é o
 * que mantém o token do CMS fora do navegador). Ver `apis/journeys.server.ts`.
 *
 * Sem SSR (ex.: `start:client` puro) a árvore vem vazia e as telas caem no
 * estado vazio, em vez de quebrar.
 */
export function useJourneyTree(): IJourney[] {
  const { serverData } = useWebgate();

  return serverData?.journeyTree || getServerData('journeyTree', []) || [];
}
